var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.overlayTransition } }, [
    _vm.visibility.overlay
      ? _c(
          "div",
          {
            ref: "overlay",
            class: _vm.overlayClass,
            attrs: {
              "aria-expanded": _vm.visibility.overlay.toString(),
              "data-modal": _vm.name
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "v--modal-background-click",
                staticStyle: { display: "grid", "place-items": "center" },
                style: _vm.scrollable ? "overflow: hidden;" : "",
                on: {
                  mousedown: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.handleBackgroundClick.apply(null, arguments)
                  },
                  touchstart: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.handleBackgroundClick.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "v--modal-top-right" },
                  [_vm._t("top-right")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  {
                    attrs: { name: _vm.transition },
                    on: {
                      "before-enter": _vm.beforeTransitionEnter,
                      "after-enter": _vm.afterTransitionEnter,
                      "after-leave": _vm.afterTransitionLeave
                    }
                  },
                  [
                    _vm.visibility.modal
                      ? _c(
                          "div",
                          {
                            ref: "modal",
                            class: _vm.modalClass,
                            style: _vm.modalStyle
                          },
                          [
                            _vm._t("default"),
                            _vm._v(" "),
                            _vm.resizable && !_vm.isAutoHeight
                              ? _c("resizer", {
                                  attrs: {
                                    "min-width": _vm.minWidth,
                                    "min-height": _vm.minHeight
                                  },
                                  on: { resize: _vm.handleModalResize }
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c87f7f36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c87f7f36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/modal/Modal.vue
// module id = null
// module chunks = 